import { SelectFuncionario } from 'global/components/Selects'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import DigitacaoToolbar from './toolbar'

export default function TodosToolbar() {
    const { view } = useDigitacaoContext()
    const isMobile = window.innerWidth <= 850

    return (
        <DigitacaoToolbar>
            {view === 'mensal' && (
                <SelectFuncionario
                    width={isMobile ? 250 : 320}
                    size="small"
                    variant="standard"
                    button
                    ativos
                />
            )}
        </DigitacaoToolbar>
    )
}
